import { Moment } from 'moment';

import { make, makeArray, makeUnix } from '../Model';
import { PodReportingDataExtended } from '../PodReportingDataExtended';
import { PodReportingOverviewSummary } from './PodReportingOverviewSummary';

export class PodReportingOverview {
  lastUpdatedAt?: Moment;

  programs: PodReportingDataExtended[];

  summary: PodReportingOverviewSummary;

  constructor(obj: any) {
    Object.assign(this, obj);
    this.lastUpdatedAt = makeUnix(obj.lastUpdatedAt);
    this.programs = makeArray(obj.programs, PodReportingDataExtended) || [];
    this.summary = make(obj.summary, PodReportingOverviewSummary) || [];
  }
}

export default PodReportingOverview;
